'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALL_API = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _http = require('../utils/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CALL_API = exports.CALL_API = 'MASON_CALL_API';

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var callAPI = action[CALL_API];

      if (callAPI === undefined) {
        return next(action);
      }

      if (_lodash2.default.isFunction(callAPI)) {
        callAPI = callAPI(store.getState);
      }

      var _callAPI = callAPI,
          endpoint = _callAPI.endpoint,
          headers = _callAPI.headers,
          verb = _callAPI.verb,
          lifecycleActions = _callAPI.lifecycleActions,
          data = _callAPI.data;

      if (!endpoint) {
        return next({
          type: 'NOOP'
        });
      }

      if (_lodash2.default.find(_http2.default.Types, function (t) {
        return t === verb;
      }) === undefined) {
        throw new Error('Invalid type');
      }

      if (!_lodash2.default.isArray(lifecycleActions) || lifecycleActions.length !== 3) {
        throw new Error('Must provide 3 lifecycle actions');
      }

      var actionWith = function actionWith(data) {
        var finalAction = Object.assign({}, action, data);
        delete finalAction[CALL_API];
        return finalAction;
      };

      var _lifecycleActions = _slicedToArray(lifecycleActions, 3),
          requestActionCreator = _lifecycleActions[0],
          successActionCreator = _lifecycleActions[1],
          failureActionCreator = _lifecycleActions[2];

      if (_lodash2.default.isEmpty(endpoint) || !_lodash2.default.startsWith(endpoint, 'http')) {
        next(actionWith(failureActionCreator({
          error: 'Invalid endpoint'
        })));
        return null;
      }

      next(actionWith(requestActionCreator(data)));

      var dispatchOrNext = function dispatchOrNext(action) {
        if (_lodash2.default.has(action, CALL_API)) {
          store.dispatch(action);
        } else {
          next(actionWith(action));
        }
      };

      return _http2.default.makeCall({
        url: endpoint,
        headers: headers,
        verb: verb,
        data: data
      }).then(function (response) {
        return dispatchOrNext(successActionCreator(response));
      }, function (response) {
        return dispatchOrNext(failureActionCreator(response));
      });
    };
  };
};